import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, PropType } from 'vue';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'UiTitle',
  props: {
  type: { type: String as PropType<'h1' |'h2' |'h3'>, default: 'h1' },
  code: { type: String, default: '' },
  align: { type: String as PropType<'left' | 'center' | 'right'>, default: 'center' },
  color: { type: String as PropType<'primary' | 'gray' | 'white'>, default: 'gray' },
  size: { type: String as PropType<'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '5xl' | '7xl'>, default: '5xl' },
  subtitleColor: { type: String as PropType<'primary' | 'gray' | 'white'>, default: 'primary' },
  animation: {
    type: String as PropType<'slideDown' | 'slideUp' | 'slideLeft' | 'slideRight' | 'fadeIn'>,
    default: '',
  },
},
  setup(__props) {

const props = __props;

// Data
const colorClasses = {
  primary: 'text-primary',
  gray: 'text-gray-900 dark:text-white',
  white: 'text-white',
};

const subtitleColorClasses = {
  primary: 'text-primary',
  gray: 'text-gray-500 dark:text-white',
  white: 'text-white',
};

const sizeClasses = {
  xs: 'text-xs sm:text-xs',
  sm: 'text-sm sm:text-sm',
  base: 'text-base sm:text-base',
  lg: 'text-lg sm:text-lg',
  xl: 'text-xl sm:text-xl',
  '2xl': 'text-2xl sm:text-2xl',
  '3xl': 'text-3xl sm:text-3xl',
  '5xl': 'text-5xl sm:text-5xl',
  '7xl': 'text-7xl sm:text-7xl',
};

const alignClasses = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

const animationMap = {
  slideDown: 'animate-slide-down',
  slideUp: 'animate-slide-up',
  slideLeft: 'animate-slide-left',
  slideRight: 'animate-slide-right',
  fadeIn: 'animate-fade-in',
};

// Computed
const subtitleClass = computed(() => `text-base font-semibold ${subtitleColorClasses[props.subtitleColor]}`);
const titleClass = computed(() => `mt-4 ${sizeClasses[props.size]} font-semibold tracking-tight text-balance ${colorClasses[props.color]}`);
const alignClass = computed(() => alignClasses[props.align]);
const animationClass = computed(() => animationMap[props.animation]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([alignClass.value, animationClass.value])
  }, [
    _createElementVNode("p", {
      class: _normalizeClass(subtitleClass.value)
    }, _toDisplayString(__props.code), 3),
    (__props.type === 'h1')
      ? (_openBlock(), _createElementBlock("h1", {
          key: 0,
          class: _normalizeClass([titleClass.value])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : _createCommentVNode("", true),
    (__props.type === 'h2')
      ? (_openBlock(), _createElementBlock("h2", {
          key: 1,
          class: _normalizeClass([titleClass.value])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : _createCommentVNode("", true),
    (__props.type === 'h3')
      ? (_openBlock(), _createElementBlock("h3", {
          key: 2,
          class: _normalizeClass([titleClass.value])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})